export const NewsController = {
    index(): void {},
    show(): void {},
};
